import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Cover from '../../components/cover/cover'
import ContactForm from '../../components/form/form'

// image imports
import cover from "../../images/melbourne-cover.jpg"

const MelbournePage = () => (
  <Layout>
    <SEO title="Melbourne Chapter" />
    <Cover
      image={cover}
      title={`We Clothe Them, Melbourne`}
    />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading `}>Chapters &middot; Melbourne</h6>
        <h2 className={``}>About the Chapter</h2>
        <p className={``}>
        Melbourne Chapter initiated in January'18 in the fancy Wheeler Centre building for Books, Writing and Ideas. It was coordinated by the amazing Sarah Vincent (Membership Officer at Writers Victoria). We collected around 100 clothes in a short period of time and donated the collected clothes to the Salvation Army in Balwyn. This drive is particularly special to We Clothe Them because it was our first attempt at making a difference at an International level and with it came the joys of seeing the willingness of people to donate and the peculiar contentment of spreading smiles beyond our boundaries of comfort zone.
        </p>
      </div>
    </section>
    <section className={`grey sm`}>
      <div className={`content-sm`}>
        <h2 className={``}>
          <span>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </span>{" "}
          Reach Out
        </h2>
        <div className={`chapter-contact`}>
          <p>
            <b>Email:</b> melborune@weclothethem.com
          </p>
          <p>
            <b>Contact:</b> +91-9999298196, +91-8700535580{" "}
          </p>
        </div>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section>
  </Layout>
)

export default MelbournePage
